import { bindToggleRemote } from '../../smartpak/toggleremote.js';
import { onDOMContentLoaded } from '../../dom/events.js';
import searchPage from './searchpage.js';
import { captureItemSelection, monitorPLPItemsInView } from '../../vendor/googletagmanager/spevents/plpeventlisteners.js';


onDOMContentLoaded(function () {
    const itemsInViewMonitor = monitorPLPItemsInView();
    const handlePageUpdates = () => {
        itemsInViewMonitor.refresh();
        captureItemSelection();
    };

    searchPage.init(handlePageUpdates);

    bindToggleRemote();
});

